import React from 'react';

import { linker, getGetCardsQueryKey } from '@vlabs/api/point-api/client';
import { PlusIcon } from '@vlabs/icons';
import { IconButton } from '@vlabs/uikit/components/controls/button/icon-button';
import type { IconButtonProps } from '@vlabs/uikit/components/controls/button/icon-button';
import type { WithDataTestid } from '@vlabs/uikit/types';

import { buildTestid } from '@vlabs/monokit/shared/lib/utils';

import { useAttachCardToListTranslation } from './i18n';
import { useAttachCardsToList } from './useAttachCardsToList';

const displayName = 'AttachCardsToListIconButton';
const testid = buildTestid(displayName);

export interface AttachCardsToListButtonProps extends
  WithDataTestid,
  IconButtonProps {
  cardIds: string[];
}

export function AttachCardsToListIconButton({
  cardIds,
  'data-testid': dataTestId = undefined,
  ...props
}: AttachCardsToListButtonProps): React.JSX.Element {
  const { t } = useAttachCardToListTranslation();
  const { open, form } = useAttachCardsToList(cardIds, linker, getGetCardsQueryKey());

  return (
    <React.Fragment>
      {form}
      <IconButton
        icon={<PlusIcon />}
        kind="secondary"
        onClick={open}
        title={t('attach_button')}
        {...testid(dataTestId)}
        {...props}
      />
    </React.Fragment>
  );
}
